import { checkNullish } from '../../helpers/checkNullish';

export const addHistorySearch = (value: string) => {
  if (!value) return;

  const FAKE_DATA: string =
    checkNullish(localStorage.getItem('searchHistory')) || '';
  const history: Array<string> = FAKE_DATA ? JSON.parse(FAKE_DATA) : [];

  let slicedIndex = undefined;
  history.forEach((item: string, index: number) => {
    if (item === value) slicedIndex = index;
  });

  slicedIndex !== undefined && history.splice(slicedIndex, 1);
  history.unshift(value);

  if (history.length > 5) history.pop();

  localStorage.setItem('searchHistory', JSON.stringify(history));
};
